module.exports = __webpack_public_path__ + "static/media/MediaPage.496babb3.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Misc/Contents/MediaPage.md
// module id = 1724
// module chunks = 0